import { Button, Flex, Text, Box, Image, Badge } from "@chakra-ui/react";
import { CalenderIcon } from "../../assets/icons/calenderIcon";
import { useTranslation } from "react-i18next";
import { formatDateToISO } from "@root/utils/date-helper";
import { REQUIREMENT_TYPE, ROUTE_NAMES } from "@root/constants";
import { useNavigate } from "react-router-dom";
import defaultThumbnail from "@root/assets/images/Course Thunbnail.png";

const DEFAULT_THUMBNAIL = defaultThumbnail;

interface MobileWatchLaterProps {
  courseDetail: any;
}

const MobileWatchLater: React.FC<MobileWatchLaterProps> = ({
  courseDetail,
}) => {
  const { t } = useTranslation("common");
  const navigate = useNavigate();

  return (
    <Box
      w="100%"
      borderRadius="12px"
      borderWidth="1px"
      borderColor="#CDD6DC"
      bg="white"
      overflow="hidden"
      mb="16px"
    >
      <Flex direction="row" gap="16px" p="16px">
        {/* Image */}
        <Box
          w="120px"
          h="120px"
          flexShrink={0}
          borderRadius="12px"
          overflow="hidden"
        >
          <Image
            src={courseDetail?.thumbnail || DEFAULT_THUMBNAIL}
            objectFit="contain"
            w="100%"
            h="100%"
          />
        </Box>

        {/* Content */}
        <Flex direction="column" flex="1" gap="8px">
          {/* Title */}
          <Text
            fontSize="16px"
            fontWeight="600"
            color="#2F2F34"
            lineHeight="1.2"
            noOfLines={2}
          >
            {courseDetail?.title}
          </Text>

          {/* Date */}
          <Flex alignItems="center" gap="8px">
            <CalenderIcon color="#5C6670" />
            <Text fontSize="14px" color="#5C6670">
              {formatDateToISO(courseDetail?.updatedAt)}{" "}
              {courseDetail?.duration}
            </Text>
          </Flex>

          {/* Requirement Badge */}
          <Badge
            bg={"white"}
            color={
              courseDetail?.requirement === REQUIREMENT_TYPE.REQUIRED
                ? "#3A59D1"
                : "#FE6807"
            }
            borderRadius="16px"
            px="12px"
            py="4px"
            fontSize="12px"
            fontWeight="600"
            border={" 1px solid #CDD6DC"}
            w="fit-content"
            textTransform="none"
          >
            {courseDetail?.requirement === REQUIREMENT_TYPE.REQUIRED
              ? "Required"
              : courseDetail?.requirement === REQUIREMENT_TYPE.OPTIONAL
              ? "Optional"
              : ""}
          </Badge>
        </Flex>
      </Flex>

      {/* View Details Button */}
      <Button
        w="100%"
        h="48px"
        bg="#1819B4"
        color="white"
        borderRadius="0"
        fontSize="16px"
        fontWeight="500"
        onClick={() =>
          navigate(
            `${ROUTE_NAMES.JOURNALIST_COURSE_DETAIL}/${courseDetail?.id}`
          )
        }
        _hover={{ bg: "#1415A0" }}
      >
        {t("myLearningDashboard.viewDetails")}
      </Button>
    </Box>
  );
};

export default MobileWatchLater;
